import React, { useContext, useEffect, useState } from 'react';
import { Box, TextField, Button, Typography, CircularProgress, Alert } from '@mui/material';
import { login } from '../services/AuthService';

import { AuthContext } from "../utils/AuthContext";
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import { ToastContainer, toast } from 'react-toastify';
import { sendResetLink } from '../services/ResetPasswordService';

import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';



const ForgotPassword = () => {
  const [email, setEmail] = useState('');

  const [emailError, setEmailError] = useState('');


  const navigate = useNavigate();

  const { auth, setAuth } = useContext(AuthContext);

  const [searchParams, setSearchParams] = useSearchParams();

  const [isLoading, setLoading] = useState(false);

  const [isSuccessAlertShowing, setSuccessAlertShowing] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const [isErrorAlertShowing, setErrorAlertShowing] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (auth?.user) {
      handleNavigation(auth?.user);
    }
  }, []);


  function validate() {
    setEmailError('');


    let isValid = true;

    const email_trimmed = email.trim();


    if (email_trimmed === '') {
      setEmailError('Email is required')
      isValid = false
    } else if (email_trimmed.length > 50) {
      setEmailError('Email is too long')
      isValid = false
    }


    return isValid;
  }

  function handleSubmit(event) {
    event.preventDefault();
    let isValid = validate()

    if (!isValid) {
      return
    }

    setErrorAlertShowing(false);
    setSuccessAlertShowing(false);


    handleSendResetLink();
  }

  async function handleSendResetLink() {
    try {
      setLoading(true);

      const res = await sendResetLink({ email });

      setSuccessMessage(res?.data?.message);
      setSuccessAlertShowing(true);

      setLoading(false);
    } catch (error) {
      // Handle error with toast notification
      // toast.error(error.response?.data?.message || 'An error occurred', {
      //     autoClose: 2000,
      //     hideProgressBar: true,
      // });

      setErrorMessage(error.response?.data?.message);
      setErrorAlertShowing(true);
    } finally {
      setLoading(false);
    }
  }

  function handleNavigation(user) {


    if (user.user_type === 'Agent') {
      navigate('/overview');
    } else if (user.user_type === 'Admin') {
      navigate('/clients');
    }
  }

  // useEffect(() => {
  //     if (auth.token) {
  //         navigate('/overview');
  //     }
  // }, []);

  return (
    <Box sx={{
      overflow: 'hidden',
      height: { xs: '100vh', md: '100vh' },
      width: { xs: '100vw', md: '100vw' },
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      background: '#fff',
      opacity: 0,
      animation: 'fadeInPage 1.5s ease forwards', // Fade-in effect for entire page
      '@keyframes fadeInPage': {
        '0%': { opacity: 0 },
        '100%': { opacity: 1 },
      },
      // backgroundImage: { xs: `url(${process.env.PUBLIC_URL + "/images/login-image.png"})`, md: 'none' },
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}>


      {/* Left side with image (only shown on desktop) */}
      <Box sx={{
        flex: { xs: 0, md: 1 },
        display: { xs: 'none', md: 'flex' },
        justifyContent: 'center',
        alignItems: 'center',
        animation: 'fadeIn 1s ease-in-out', // Fade-in animation for background image
        '@keyframes fadeIn': {
          '0%': { opacity: 0 },
          '100%': { opacity: 1 },
        },
      }}>
        <img
          src={process.env.PUBLIC_URL + "/images/login-image.png"}
          alt="Login Illustration"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </Box>

      {/* Right side with login form */}
      <Box sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        width: { xs: '100%', md: '50%' },
        backdropFilter: { xs: 'blur(8px)', md: 'none' }, // Optional blur for mobile background
        animation: 'fadeInUp 0.6s ease-out', // Fade-in and slide-up effect for form container
        '@keyframes fadeInUp': {
          '0%': { opacity: 0, transform: 'translateY(20px)' },
          '100%': { opacity: 1, transform: 'translateY(0)' },
        },
      }}>
        <Box sx={{ pl: { xs: 2, md: 3 }, pt: { xs: 5, md: 3 } }}>
          <Typography variant='h5' className="agent-title">
            Agent
          </Typography>
          <Typography variant='h5' sx={{ color: '#3328BF' }} className="connect-title">
            Connect+
          </Typography>
        </Box>

        <Box sx={{
          flex: { xs: .7, md: .9 },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          px: { xs: 4, sm: 8, md: 15, lg: 25 },
        }}>
          {/* <ToastContainer /> */}

          <Typography variant="h4" sx={{ mb: 2 }}>
            Recover Account
          </Typography>


          {
            isSuccessAlertShowing &&
            <Alert
              sx={{ mb: 2, }}
              severity="success"
              onClose={() => { setSuccessAlertShowing(false) }}
              icon={<CheckOutlinedIcon fontSize="inherit" />}
            >{successMessage}</Alert>
          }

          {
            isErrorAlertShowing &&
            <Alert
              sx={{ mb: 2, }}
              severity="error"
              onClose={() => { setErrorAlertShowing(false) }}
              icon={<CloseOutlinedIcon fontSize="inherit" />}
            >{errorMessage}</Alert>
          }

          <form onSubmit={handleSubmit}>
            <TextField
              label="Email"
              variant="filled"
              fullWidth
              sx={{
                mb: 2,
                '& .MuiFilledInput-root': {
                  transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                  '&.Mui-focused': {
                    boxShadow: '0 0 5px rgba(51, 40, 191, 0.4)',
                  },
                },
              }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email" // Placeholder text
              autoComplete='email'
              type='email'
              error={emailError !== ''}
              helperText={emailError}
              autoFocus
            />

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  disabled={isLoading}
                  variant="contained"
                  type='submit'
                  sx={{
                    height: { xs: '45px', sm: '40px' },
                    width: { xs: '100%', sm: '200px' },
                    background: '#3328BF',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    overflow: 'hidden',
                    '&:hover': {
                      background: '#2a20a0',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 4px 20px rgba(51, 40, 191, 0.2)',
                    },
                    '&:active': {
                      transform: 'translateY(1px)',
                    },
                    '&::after': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      background: 'linear-gradient(120deg, transparent, rgba(255,255,255,0.2), transparent)',
                      transform: 'translateX(-100%)',
                    },
                    '&:hover::after': {
                      transform: 'translateX(100%)',
                      transition: 'transform 0.5s ease',
                    }
                  }}
                >
                  {/* {isLoading ? 'Loading...' : 'Login'} */}

                  Send Reset Link
                </Button>

                {
                  isLoading && <CircularProgress size={24} sx={{ ml: 2 }} />
                }

              </Box>
              <Button to="/login" LinkComponent={Link}>Back to Login</Button>
            </Box>

          </form>
        </Box>
      </Box>
    </Box>
  );
};

export default ForgotPassword;
